<template>
  <v-layout :column="column" class="app-select-container">

    <v-flex v-if="label" class="label-flex" :class="labelClass">
      <v-card-text class="app-input-label">
        <v-layout class="align-center">
          <v-flex shrink>
            <slot name="label-prepend"></slot>
          </v-flex>
          <v-flex grow>{{$t(label)}}</v-flex>
          <v-flex shrink>
            <slot name="label-append"></slot>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-flex>

    <v-flex class="input-flex" :class="inputClass" v-bind="inputFlexAttrs">

      <v-select :value="value" @input="input" :class="defaultClass" :menu-props="selectMenuProps" :rules="validationRules" validate-on-blur
        v-bind="$attrs" @change="change" dense>
        <template v-slot:append>
          <slot name="append"></slot>
        </template>
        <template v-slot:append-item>
          <slot name="append-item"></slot>
        </template>
        <template v-slot:append-outer>
          <slot name="append-outer"></slot>
        </template>
        <template v-slot:prepend>
          <slot name="prepend"></slot>
        </template>
        <template v-slot:prepend-inner>
          <slot name="prepend-inner"></slot>
        </template>
        <template v-slot:prepend-item>
          <slot name="prepend-item"></slot>
        </template>
        <template v-slot:selection="props" v-if="'use-item-slot' in $attrs">
          <slot name="selection" v-bind="props">
          </slot>
        </template>
        <template v-slot:item="props" v-if="'use-item-slot' in $attrs">
          <slot name="item" v-bind="props">
          </slot>
        </template>
      </v-select>
    </v-flex>
  </v-layout>
</template>

<script>
import { actions as _act } from '@/models/store.actions';
import { getLocale } from '@/helpers/locale-helper';

export default {
  name: 'AppSelect',
  inheritAttrs: false,
  data: function() {
    return {
      column: true,
      inputFlexAttrs: {},
      row: false,
      rulesPreset: {
        required: v => !!v || getLocale('validate.exist')
      },
      // selectMenuProps: { bottom: true, offsetY: true, contentClass: 'select-menu' },
      validationRules: []
    };
  },
  props: {
    inputClass: { default: '' },
    label: { default: '' },
    labelClass: { default: '' },
    menuProps: {},
    rules: undefined,
    value: { default: '' },
    defaultClass: { default: 'app-select' }
  },
  created() {
    // this.selectMenuProps = Object.assign(this.selectMenuProps, this.menuProps);

    if ('row' in this.$attrs) {
      this.column = false;
      this.row = true;
    }

    let sizes = Object.keys(this.$attrs).filter(a => /^xs|sm|md|lg|xl/.test(a));
    sizes.forEach(s => (this.inputFlexAttrs[s] = ''));

    if ('required' in this.$attrs) {
      this.validationRules.push(this.rulesPreset.required);
    }

    this.validationRules = this.validationRules.concat(this.$props.rules || []);
  },
  computed: {
    appSettings() {
      return this.$store.getters[_act.SETT_GET_APPSET];
    },
    selectMenuProps() {
      return Object.assign({ bottom: true, offsetY: true, contentClass: 'select-menu' }, this.menuProps);
    }
  },
  methods: {
    input(val) {
      this.$emit('input', val);
    },
    change(val) {
      this.$emit('change', val);
    }
  }
};
</script>
